import React from 'react';
import { styled } from '@mui/material';
import { Checkbox, Chip, MultiSelect, Row, Stack, Text } from 'library/ui';
import { Colors } from 'library';
import { IBusinessLocation } from 'models';

interface ISelectLocationsProps {
    availableLocations: IBusinessLocation[];
    selectedLocations: number[];
    allLocationsSelected: boolean;
    onLocationsChange: (ids: number[]) => void;
    onSelectAll: () => void;
}

export default function SelectLocations({
    availableLocations,
    selectedLocations,
    allLocationsSelected,
    onLocationsChange,
    onSelectAll,
}: ISelectLocationsProps) {
    const selected = availableLocations.filter((x) => selectedLocations.includes(x.id));

    return (
        <Stack gap="sm">
            <Text weight="semibold">Select Location Access*</Text>
            <Checkbox
                label="All Locations (same access everywhere)"
                checked={allLocationsSelected}
                onChange={onSelectAll}
            />
            {!allLocationsSelected && (
                <>
                    <MultiSelect
                        value={selectedLocations.map(String)}
                        onChange={(keys) => onLocationsChange(keys.map(Number))}
                        options={availableLocations.map((x) => ({ key: String(x.id), value: x.name }))}
                        placeholder="Choose locations..."
                        tone="primary"
                        fullWidth
                        renderSummary={(labels) =>
                            labels.length === 1
                                ? labels[0]
                                : `${labels.length} of ${availableLocations.length} locations`
                        }
                    />
                    {selected.length > 0 && (
                        <Row gap="sm" wrap>
                            {selected.map((x) => (
                                <Chip
                                    key={x.id}
                                    size="small"
                                    variant="filled"
                                    bgColor={Colors.secondarySoft}
                                    textColor={Colors.primary}
                                    removable
                                    onRemove={() => onLocationsChange(selectedLocations.filter((id) => id !== x.id))}
                                >
                                    {x.name}
                                </Chip>
                            ))}
                        </Row>
                    )}
                    <Hint>
                        <Text size="xs" tone="secondary">
                            Permissions are set per selected location below.
                        </Text>
                    </Hint>
                </>
            )}
        </Stack>
    );
}

const Hint = styled('div')({
    marginTop: -4,
});
